import './index.less'
import React from "react";
import { Form, Input, Button, Row, Col, Icon, notification } from "antd";
import { loginUser } from '../../actions/auth';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";


const FormItem = Form.Item;

const mapStateToProps = (state) => {
  return {
    user: state.user,
    errorMessage: state.errorMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    tryLogin: (login, password) => dispatch(loginUser(login, password)),
    eraseError: () => dispatch({type: 'ERASE_ERROR'})
  }
}

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: null,
      password: null,
      loading: false
    };
    this.setAuthData = this.setAuthData.bind(this)
    this.tryToLoggin = this.tryToLoggin.bind(this)
  }
  

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && (nextProps.user !== this.props.user) && nextProps.user.account_id) {
      this.setState({loading:false})
      notification.success({
        message: `Login as ${nextProps.user.first_name}`,
        duration: 2
      })
    } 
    if (nextProps.errorMessage) {
      this.setState({loading:false})
      notification.error({
        message: `Login error ${nextProps.errorMessage}`,
        duration: 2
      })
    }
  }


  tryToLoggin(e) {
    e.preventDefault();
    this.props.tryLogin(
        this.state.login,
        this.state.password
      );
    this.setState({loading: true});
    this.props.eraseError()
  }


  setAuthData(fieldName, value) {
    let stateObject = {}
    stateObject[fieldName] = value
    this.setState(stateObject)
  }



  render() {
    if (this.props.user.username) {
      return (<Redirect to="/" />);
    } else {
      return (
        <Row
          className="login-row"
          type="flex"
          justify="space-around"
          align="middle"
        >
          <Col>
            <Form layout="horizontal" className="login-form" id="login-form">
              <div className="logo"/>
              <FormItem>
                <Input
                  prefix={<Icon type="user" style={{ fontSize: 13 }} />}
                  placeholder="Login"
                  id="login-input-field"
                  onChange={(e) => this.setAuthData('login',e.target.value)}
                />
              </FormItem>
              <FormItem>
                <Input
                  prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                  type="password"
                  placeholder="Password"
                  id="password-input-field"
                  onChange={(e) => this.setAuthData('password',e.target.value)}
                />
              </FormItem>
              <div className="login-button-block">
                <Button
                  // className="btn-login"
                  type="primary"
                  size="large"
                  icon="poweroff"
                  id="login-button"
                  loading={this.state.loading}
                  htmlType="submit"
                  onClick={(e) => this.tryToLoggin(e)}
                >
                  Login
                </Button>
              </div>
              <p>
              </p>
            </Form>
          </Col>
        </Row>
      );
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/views/Login/index.jsx